import React from 'react';
import { withTheme } from 'styled-components';
import { MyThemeProvider } from '@theme/ThemeContext';

const App = ({ children }) => <MyThemeProvider>{children}</MyThemeProvider>;

export default withTheme(App);
